import React from "react";
import {Typography} from "@mui/material";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";

export interface IMotorcycleDetailsConfig {
    param: keyof IMotorcycle;
    locaId: IdlocaGeneric;
    renderer?: React.FC<{value: any}>;
}

interface IDefaultRenderer {
    value: any;
    color?: string;
}

// TODO use theme colors

const DefaultRenderer: React.FC<IDefaultRenderer> = ({
    value,
    color,
}) =>
    (
        <Typography variant="body2"
            style={{
                fontWeight: 500,
                color: color ?? "#4f4f4f",
            }}>
            {value ?? "N/A"}
        </Typography>
    );
const EngineSizeRenderer: React.FC<{value: any}> = ({value}) => (
    <Typography variant="body2"
        style={{
            fontWeight: 600,
            color: "#23619f",
        }}>
        {value ? `${value} cc` : "N/A"}
    </Typography>
);
const WeightRenderer: React.FC<{value: any}> = ({value}) => (
    <Typography variant="body2"
        style={{
            fontWeight: 600,
            color: "#9a3f3f",
        }}>
        {value ? `${value} kg` : "N/A"}
    </Typography>
);
export const motorcycleDetailsConfig: IMotorcycleDetailsConfig[] = [
    {
        param: "makerName",
        locaId: IdlocaGeneric.maker_name,
    },
    {
        param: "modelName",
        locaId: IdlocaGeneric.model_name,
    },
    {
        param: "typeName",
        locaId: IdlocaGeneric.type_name,
    },
    {
        param: "engineSize",
        locaId: IdlocaGeneric.engine_size,
        renderer: EngineSizeRenderer,
    },
    {
        param: "dryWeight",
        locaId: IdlocaGeneric.dry_weight,
        renderer: WeightRenderer,
    },
    {
        param: "boreXStroke",
        locaId: IdlocaGeneric.bore_x_stroke,
    },
    {
        param: "category",
        locaId: IdlocaGeneric.category,
    },
    {
        param: "clutch",
        locaId: IdlocaGeneric.clutch,
    },
    {
        param: "compression",
        locaId: IdlocaGeneric.compression,
    },
    {
        param: "coolingSystem",
        locaId: IdlocaGeneric.cooling_system,
    },
    {
        param: "displacement",
        locaId: IdlocaGeneric.displacement,
    },
    {
        param: "frontBrakes",
        locaId: IdlocaGeneric.front_brakes,
    },
    {
        param: "frontSuspension",
        locaId: IdlocaGeneric.front_suspension,
    },
    {
        param: "fuelCapacity",
        locaId: IdlocaGeneric.fuel_capacity,
        renderer: ({value}) => <DefaultRenderer value={value}/>,
    },
    {
        param: "gearbox",
        locaId: IdlocaGeneric.gearbox,
    },
    {
        param: "powerOutput",
        locaId: IdlocaGeneric.power_output,
        renderer: ({value}) => <DefaultRenderer value={value}/>,
    },
    {
        param: "topSpeed",
        locaId: IdlocaGeneric.top_speed,
        renderer: ({value}) => <DefaultRenderer value={value} color="#009809"/>,
    },
    {
        param: "torque",
        locaId: IdlocaGeneric.torque,
        renderer: ({value}) => <DefaultRenderer value={value}/>,
    },
    {
        param: "seatHeight",
        locaId: IdlocaGeneric.seat_height,
        renderer: ({value}) => <DefaultRenderer value={value}/>,
    },
    {
        param: "wheelbase",
        locaId: IdlocaGeneric.wheelbase,
        renderer: ({value}) => <DefaultRenderer value={value}/>,
    },
    {
        param: "year",
        locaId: IdlocaGeneric.year,
    },
];
